
import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";
import FormValidator from "@/components/mixins/FormValidator";
import { Debounce } from "vue-debounce-decorator";

interface SelectOption {
  value: number | any;
  label: string;
}

interface Tipos {
  value: number | any;
  label: string;
}

@Component({
  components: {
    FormValidator
  }
})
export default class StepDatosPersonales extends Mixins(FormValidator) {
  @Prop({ required: true })
  private data!: any;
  @Prop({ required: true })
  private rut!: string;
  @Prop({ required: true })
  private tipoVecino!: any;
  @Prop({ required: true })
  private flotante!: any;
  @Prop({ required: true })
  private directoForm!: any;
  private dataForm = {
    parentesco: null as number | any,
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    rut: "",
    fechaNacimiento: null as Date | any,
    estadoCivil: null as number | null,
    sexo: null as number | null,
    nacionalidad: null as number | null,
    email: "",
    telefono: "",
    profesion: "" as string | undefined,
    ocupacion: "" as string | undefined,
    tipoVecino: null as number | null,
    nombreEntidad: "" as string | undefined
  };
  private paisesList: any[] = [];
  private ocupacionList: any[] = [];
  private ocupacionListOptions: Array<any> = [];
  private selected: Boolean = false;
  private formattedFecha = "";
  private titular: string = "si";
  private typeOptions: Array<any> = [];
  private genderOptions: SelectOption[] = [];
  private paisesOptions: SelectOption[] = [];
  private vOptions: SelectOption[] = [];
  private cStateOptions: SelectOption[] = [];
  private dataParentesco: Tipos = {
    value: null,
    label: ""
  };
  private dataSexo: Tipos = {
    value: null,
    label: " "
  };

  private dataEstadoCivil: Tipos = {
    value: null,
    label: " "
  };

  private dataNation: Tipos = {
    value: null,
    label: " "
  };

  private dataOcupacion: Tipos = {
    value: null,
    label: " "
  };

  private dataTipoVecino: Tipos = {
    value: null,
    label: " "
  };

  private localeCalendar = {
    days: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    ],
    daysShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
    months: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    monthsShort: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic"
    ]
  };

  @Watch("formattedFecha")
  @Debounce(1000)
  private edadWatcher(newValue: any) {
    const now = new Date(Date.now());
    if (typeof newValue == "object") {
      let day = newValue.getDate();
      let month = newValue.getMonth() + 1;
      let year = newValue.getFullYear();
      if (month < 10) {
        if (day < 10) {
          newValue = `0${day}/0${month}/${year}`;
        } else {
          newValue = `${day}/0${month}/${year}`;
        }
      } else {
        if (day < 10) {
          newValue = `0${day}/${month}/${year}`;
        } else {
          newValue = `${day}/${month}/${year}`;
        }
      }
    }
    var birthDate: any = "";
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") != -1) {
      if (ua.indexOf("chrome") > -1) {
        birthDate = (newValue.substring(6, 10) +
          "-" +
          newValue.substring(3, 5) +
          "-" +
          newValue.substring(0, 2) +
          " 12:00:00") as any;
      } else {
        birthDate = (newValue.substring(6, 10) +
          "-" +
          newValue.substring(3, 5) +
          "-" +
          newValue.substring(0, 2) +
          "T12:00:00") as any;
      }
    } else if (ua.indexOf("mozilla") != -1) {
      //Usa Mozilla
      birthDate = (newValue.substring(6, 10) +
        "-" +
        newValue.substring(3, 5) +
        "-" +
        newValue.substring(0, 2) +
        "T12:00:00") as any;
    }

    if (birthDate && birthDate.length <= 18) {
      // this.$swal({
      //   icon: "error",
      //   title: this.$t("notifications.titles.form").toString(),
      //   text: this.$t("notifications.error.FORMAT_BIRTH").toString(),
      //   confirmButtonText: this.$t("buttons.accept").toString(),
      // });
      this.dataForm.fechaNacimiento = null;
      return;
    }

    let diff;
    if (birthDate instanceof Date) {
      diff = now.getTime() - birthDate.getTime();
      this.dataForm.fechaNacimiento = birthDate;
    } else {
      diff = now.getTime() - new Date(birthDate).getTime();
      const dateParts = birthDate
        .split(/-|\s|:/)
        .map(part => parseInt(part, 10));

      const año = dateParts[0];
      const mes = dateParts[1];
      const dia = dateParts[2];
      const result = this.validFechaNacimiento(año, mes, dia);
      if (result == false) {
        this.formattedFecha = "";
      }

      let fecha = new Date(birthDate);

      this.dataForm.fechaNacimiento = fecha;
      if (this.dataForm.fechaNacimiento == "Invalid Date") {
        this.dataForm.fechaNacimiento = null;
      }
      this.dataForm.fechaNacimiento = new Date(birthDate);
    }
  }

  @Watch("dataParentesco")
  private parentescoWatcher(newValue: any) {
    this.selected = true;
    this.dataForm.parentesco = newValue.value;
  }

  @Watch("dataSexo")
  private sexoWatcher(newValue: any) {
    this.dataForm.sexo = newValue.value;
  }

  @Watch("dataEstadoCivil")
  private estadocivilWatcher(newValue: any) {
    this.dataForm.estadoCivil = newValue.value;
  }

  @Watch("dataNation")
  private nationWatcher(newValue: any) {
    this.dataForm.nacionalidad = newValue.value;
  }

  @Watch("dataOcupacion")
  private ocupacionWatcher(newValue: any) {
    this.dataForm.ocupacion = newValue.label;
  }

  @Watch("dataTipoVecino")
  private tipoVecinoWatcher(newValue: any) {
    this.dataForm.tipoVecino = newValue.value;
  }

  private mounted() {
    if (this.tipoVecino == 2) {
      this.dataTipoVecino.value = 2;
      this.dataTipoVecino.label = "TRABAJADOR";
      this.dataForm.tipoVecino = 2;
    } else if (this.tipoVecino == 3) {
      this.dataTipoVecino.value = 3;
      this.dataTipoVecino.label = "ESTUDIANTE";
      this.dataForm.tipoVecino = 3;
    } else {
      this.dataForm.tipoVecino = 1;
      this.dataParentesco.value = "";
    }
    this.titular = this.data.titular;

    this.$axios("parentesco")
      .then(res => {
        res.data.forEach((entry: any) => {
          this.typeOptions.push({
            value: entry.id,
            label: this.$t(`meta.type[${entry.id - 1}]`).toString()
          });
          if (entry.id == this.dataForm.parentesco) {
            this.dataParentesco.value = entry.id;
            this.dataParentesco.label = entry.nombre;
          }
        });

        this.typeOptions.sort((a, b) => (a.label <= b.label ? -1 : 1));
        // if (this.titular === "si") {
        //   this.typeOptions = this.typeOptions.filter(
        //     (element: any) => element.value !== 1
        //   );
        // }

        if (this.dataForm.parentesco === 1 || this.titular === "no") {
          this.typeOptions = this.typeOptions.filter(
            (element: any) => element.value === 1
          );
        } else {
          this.typeOptions = this.typeOptions.filter(
            (element: any) => element.value !== 1
          );
        }
      })
      .catch((error: any) => {
        if (error.response.data.message == "TOKEN_ERROR") {
          this.$swal({
            icon: "warning",
            title: this.$t("notifications.titles.atention").toString(),
            text: this.$t("notifications.error.TOKEN_ERROR").toString(),
            confirmButtonText: this.$t("buttons.accept").toString()
          });
          this.$router.push({ name: "login" }).catch(err => {});
        }
      });

    this.$axios("pais")
      .then(res => {
        this.dataNation = {
          value: res.data[44].id,
          label: res.data[44].nombre_es
        };
        if (this.$store.state.user.lenguage === "es") {
          this.paisesList.push({
            value: res.data[44].id,
            label: res.data[44].nombre_es
          });
        } else if (this.$store.state.user.lenguage === "en") {
          this.paisesList.push({
            value: res.data[44].id,
            label: res.data[44].nombre_en
          });
        }
        res.data.forEach((country: any, index: number) => {
          if (res.data.length - 1 !== index && index !== 44) {
            if (this.$store.state.user.lenguage === "es") {
              this.paisesList.push({
                value: country.id,
                label: country.nombre_es
              });
            } else if (this.$store.state.user.lenguage === "en") {
              this.paisesList.push({
                value: country.id,
                label: country.nombre_en
              });
            }
          }
          if (country.id == this.dataForm.nacionalidad) {
            this.dataNation = {
              value: country.id,
              label: country.nombre_es
            };
          }
        });
        if (this.dataForm.nacionalidad == 47) {
          this.dataNation = {
            value: this.paisesList[0].value,
            label: this.paisesList[0].label
          };
        }
      })
      .catch((error: any) => {
        if (error.response.data.message == "TOKEN_ERROR") {
          this.$swal({
            icon: "warning",
            title: this.$t("notifications.titles.atention").toString(),
            text: this.$t("notifications.error.TOKEN_ERROR").toString(),
            confirmButtonText: this.$t("buttons.accept").toString()
          });
          this.$router.push({ name: "login" }).catch(err => {});
        }
      });

    this.genderOptions.push(
      { value: 1, label: "Masculino" },
      { value: 0, label: "Femenino" },
      { value: 2, label: "Otro" },
      { value: 3, label: "Prefiero no decirlo" },
      { value: 4, label: "No Binarie" }
    );

    this.cStateOptions.push(
      { value: 0, label: this.$t("meta.status.single").toString() },
      { value: 1, label: this.$t("meta.status.married").toString() },
      { value: 2, label: this.$t("meta.status.union").toString() },
      { value: 3, label: this.$t("meta.status.divorced").toString() },
      { value: 4, label: this.$t("meta.status.null").toString() },
      { value: 5, label: this.$t("meta.status.widow").toString() }
    );

    this.vOptions.push(
      { value: 3, label: this.$t("meta.neighbor_types.student").toString() },
      { value: 2, label: this.$t("meta.neighbor_types.worker").toString() }
    );

    this.ocupaciones();
    if (this.flotante == false) {
      if (
        this.$store.state.solicitud &&
        this.$store.state.solicitud.step == 2
      ) {
        this.backStepData();
      } else {
        this.fillForm(this.data);
      }
    } else {
      if (
        this.$store.state.solicitud &&
        this.$store.state.solicitud.step == 3
      ) {
        this.backStepData();
      } else {
        this.fillForm(this.data);
      }
    }
  }

  private fillForm(data: any) {
    this.dataForm.rut = this.rut.toUpperCase();
    this.dataForm.email = this.data.email;
    if (this.data && this.data.telefono) {
      this.dataForm.telefono = this.data.telefono;
    }

    for (let j = 0; j < this.genderOptions.length; j++) {
      if (this.genderOptions[j].value == this.dataForm.sexo) {
        this.dataSexo = this.genderOptions[j];
        break;
      }
    }

    for (let j = 0; j < this.cStateOptions.length; j++) {
      if (this.cStateOptions[j].value == this.dataForm.estadoCivil) {
        this.dataEstadoCivil = this.cStateOptions[j];
        break;
      }
    }

    for (let j = 0; j < this.vOptions.length; j++) {
      if (this.vOptions[j].value == this.dataForm.tipoVecino) {
        this.dataTipoVecino = this.vOptions[j];
        break;
      }
    }
  }

  private ocupaciones() {
    this.$axios("ocupaciones").then(res => {
      res.data.forEach((ocupacion: any) => {
        this.ocupacionList.push({
          value: ocupacion.id,
          label: ocupacion.nombre
        });
      });

      for (let j = 0; j < this.ocupacionList.length; j++) {
        if (this.ocupacionList[j].label == this.dataForm.ocupacion) {
          this.dataOcupacion = this.ocupacionList[j];
          break;
        }
      }
    });
  }

  private filterFnPaises(val, update, abort) {
    update(() => {
      const needle = val.toLowerCase();
      this.paisesOptions = this.paisesList.filter(
        v => v.label.toLowerCase().indexOf(needle) > -1
      );
    });
  }
  private filterFn2(val, update, abort) {
    update(() => {
      const needle = val.toLowerCase();
      this.ocupacionListOptions = this.ocupacionList.filter(
        v => v.label.toLowerCase().indexOf(needle) > -1
      );
    });
  }

  private forceUpper(value: any) {
    if (!value) {
      return "";
    }
    value = value.toString();
    return value.toUpperCase();
  }

  private actionBack() {
    if (
      this.tipoVecino != 1 &&
      this.flotante == true &&
      this.directoForm == false
    ) {
      this.$store.dispatch("SET_STATE_TO_TWO");

      this.$emit("stepNext", {
        step: this.$store.state.solicitud.step
      });
    } else if (this.flotante == false && this.directoForm == false) {
      this.$store.dispatch("SET_STATE_TO_TWO");

      this.$emit("stepNext", {
        step: this.$store.state.solicitud.step
      });
    } else {
      this.$store.dispatch("SET_STATE_TO_ONE");

      this.$emit("stepNext", {
        step: this.$store.state.solicitud.step
      });
    }
  }

  private stepToDireccion() {
    if (
      this.dataForm.rut == "" ||
      this.validateRut(this.dataForm.rut) == false
    ) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_RUT").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (this.dataForm.parentesco == null && this.dataForm.tipoVecino == 1) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_PARENTESCO").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }

    if (this.checkFechaMayorAHoy(this.dataForm.fechaNacimiento)) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: "La fecha de nacimiento no puede ser mayor a la actual.",
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (
      this.dataForm.fechaNacimiento == null ||
      !this.checkFecha(this.dataForm.fechaNacimiento)
    ) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_BIRTH").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }

    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") != -1) {
      if (!(ua.indexOf("chrome") > -1)) {
        if (this.dataForm.fechaNacimiento.getFullYear() < 1890) {
          this.$swal({
            icon: "error",
            title: this.$t("notifications.titles.form").toString(),
            text: this.$t("notifications.error.FORMAT_BIRTH").toString(),
            confirmButtonText: this.$t("buttons.accept").toString()
          });
          return;
        }
      }
    }
    if (
      this.age < 18 &&
      (this.dataForm.tipoVecino == 3 || this.dataForm.tipoVecino == 2)
    ) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.EDAD_SOLICITUD").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }

    if (
      this.age < 18 &&
      this.dataForm.parentesco == 1 &&
      this.flotante == false
    ) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.EDAD_SOLICITUD_TITULAR").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (this.age < 18 && this.dataForm.parentesco == 2) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.EDAD_SOLICITUD_CONYUGE").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (this.age > 24 && this.dataForm.parentesco == 3) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.EDAD_SOLICITUD_HIJO").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (this.age < 5 && this.dataForm.parentesco == 3) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t(
          "notifications.error.EDAD_SOLICITUD_HIJO_MINIMA"
        ).toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }

    if (this.dataForm.nombre == "") {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_NAME").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    this.dataForm.nombre = this.forceUpper(this.dataForm.nombre);
    if (this.dataForm.apellidoPaterno == "") {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_APELLIDO").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    this.dataForm.apellidoPaterno = this.forceUpper(
      this.dataForm.apellidoPaterno
    );
    if (this.dataForm.email == "") {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_EMAIL").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    } else if (!this.validEmail(this.dataForm.email)) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.FORMAT_EMAIL").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    this.dataForm.email = this.forceUpper(this.dataForm.email);
    if (this.dataForm.telefono == "") {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_PHONE").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (this.dataForm.telefono.length < 9) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.FORMAT_PHONE").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (this.dataForm.sexo == null) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_GENERO").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (this.dataForm.nacionalidad == null) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_NACIONALIDAD").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (this.dataForm.estadoCivil == null) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_ESTADO").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (this.dataForm.nombreEntidad == "" && this.isWorker) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_EMPRESA").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    this.dataForm.nombreEntidad = this.forceUpper(this.dataForm.nombreEntidad);

    if (
      this.dataForm.nombreEntidad == "" &&
      !this.isWorker &&
      this.flotante == true
    ) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_ESTABLECIMIENTO").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (this.dataForm.tipoVecino == 2 || this.dataForm.tipoVecino == 3) {
      this.dataForm.parentesco = 1;
    }

    if (this.flotante == false && this.directoForm == true) {
      this.$store.dispatch("SUBMIT_REQUEST_STEP_TWO", this.dataForm);
      this.$store.dispatch("SET_STATE_TO_THREE");

      this.$emit("stepNext", {
        step: this.$store.state.solicitud.step
      });
    } else {
      this.$store.dispatch("SUBMIT_REQUEST_STEP_TWO", this.dataForm);
      this.$store.dispatch("SET_STATE_TO_FOUR");

      this.$emit("stepNext", {
        step: this.$store.state.solicitud.step
      });
    }
  }

  get isWorker() {
    if (this.dataForm.tipoVecino === 3) {
      return false;
    } else if (this.dataForm.tipoVecino === 2) {
      return true;
    } else {
      return null;
    }
  }

  get age() {
    const today = new Date();
    const date = this.dataForm.fechaNacimiento;
    if (date) {
      const age = (today.getTime() - date.getTime()) / (1000 * 3600 * 24 * 365);
      return age;
    }
    return 0;
  }

  private checkFechaMayorAHoy(d) {
    let hoy = new Date();
    if (d > hoy) {
      return true;
    } else {
      return false;
    }
  }

  private checkFecha(d) {
    if (Object.prototype.toString.call(d) === "[object Date]") {
      // it is a date
      if (isNaN(d.getTime())) {
        // d.valueOf() could also work
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
  private validEmail(email) {
    // eslint-disable-next-line
    let emailRegex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRegex.test(email) === true) {
      return true;
    } else {
      return false;
    }
  }
  public validateRut(newValue: string) {
    var texto = newValue;
    var tmpstr = "";
    for (let i = 0; i < texto.length; i++)
      if (
        texto.charAt(i) != " " &&
        texto.charAt(i) != "." &&
        texto.charAt(i) != "-"
      )
        tmpstr = tmpstr + texto.charAt(i);
    texto = tmpstr;
    var largo = texto.length;
    if (largo < 2) {
      return false;
    }
    for (let i = 0; i < largo; i++) {
      if (
        texto.charAt(i) != "0" &&
        texto.charAt(i) != "1" &&
        texto.charAt(i) != "2" &&
        texto.charAt(i) != "3" &&
        texto.charAt(i) != "4" &&
        texto.charAt(i) != "5" &&
        texto.charAt(i) != "6" &&
        texto.charAt(i) != "7" &&
        texto.charAt(i) != "8" &&
        texto.charAt(i) != "9" &&
        texto.charAt(i) != "k" &&
        texto.charAt(i) != "K"
      ) {
        return false;
      }
    }
    var invertido = "";
    for (let i = largo - 1, j = 0; i >= 0; i--, j++)
      invertido = invertido + texto.charAt(i);
    var dtexto = "";
    dtexto = dtexto + invertido.charAt(0);
    dtexto = dtexto + "-";
    var cnt = 0;
    for (let i = 1, j = 2; i < largo; i++, j++) {
      //alert("i=[" + i + "] j=[" + j +"]" );
      if (cnt == 3) {
        dtexto = dtexto + ".";
        j++;
        dtexto = dtexto + invertido.charAt(i);
        cnt = 1;
      } else {
        dtexto = dtexto + invertido.charAt(i);
        cnt++;
      }
    }
    invertido = "";
    for (let i = dtexto.length - 1, j = 0; i >= 0; i--, j++)
      invertido = invertido + dtexto.charAt(i);

    if (this.revisarDigito2(texto)) {
      return true;
    }
    return false;
  }
  public revisarDigito(dvr: string) {
    var dv = dvr + "";
    if (
      dv != "0" &&
      dv != "1" &&
      dv != "2" &&
      dv != "3" &&
      dv != "4" &&
      dv != "5" &&
      dv != "6" &&
      dv != "7" &&
      dv != "8" &&
      dv != "9" &&
      dv != "k" &&
      dv != "K"
    ) {
      return false;
    }
    return true;
  }
  public revisarDigito2(crut: string) {
    var largo = crut.length;
    if (largo < 2) {
      return false;
    }
    if (largo > 2) var rut = crut.substring(0, largo - 1);
    else rut = crut.charAt(0);
    var dv = crut.charAt(largo - 1);
    this.revisarDigito(dv);
    if (rut == null || dv == null) return 0;
    var dvr = "0";
    var suma = 0;
    var mul = 2;
    for (let i = rut.length - 1; i >= 0; i--) {
      suma = suma + parseInt(rut.charAt(i), 10) * mul;
      if (mul == 7) mul = 2;
      else mul++;
    }
    var res = suma % 11;
    if (res == 1) dvr = "k";
    else if (res == 0) dvr = "0";
    else {
      var dvi = 11 - res;
      dvr = dvi + "";
    }
    if (dvr != dv.toLowerCase()) {
      return false;
    }
    return true;
  }

  private backStepData() {
    if (
      this.$store.state.solicitud &&
      this.$store.state.solicitud.fechaNacimiento
    ) {
      let dia = "";
      let mes = "";
      let ano = "";
      if (this.$store.state.solicitud.fechaNacimiento.getDate() < 10) {
        dia = "0" + this.$store.state.solicitud.fechaNacimiento.getDate();
      } else {
        dia = this.$store.state.solicitud.fechaNacimiento.getDate();
      }

      if (this.$store.state.solicitud.fechaNacimiento.getMonth() < 10) {
        mes =
          "0" + (this.$store.state.solicitud.fechaNacimiento.getMonth() + 1);
      } else {
        mes = this.$store.state.solicitud.fechaNacimiento.getMonth() + 1;
      }
      ano = this.$store.state.solicitud.fechaNacimiento.getFullYear();

      let formatFechaApi = dia + "/" + mes + "/" + ano + " 12:00:00";

      this.formattedFecha = formatFechaApi;
    }

    this.dataForm.rut = this.$store.state.solicitud.rut.toUpperCase();
    this.dataForm.email = this.$store.state.solicitud.email;
    this.dataForm.telefono = this.$store.state.solicitud.telefono;
    this.dataForm.parentesco = this.$store.state.solicitud.parentesco;
    this.dataParentesco.value = this.dataForm.parentesco;
    this.dataForm.nombre = this.$store.state.solicitud.nombre;
    this.dataForm.apellidoPaterno = this.$store.state.solicitud.apellidoPaterno;
    this.dataForm.apellidoMaterno = this.$store.state.solicitud.apellidoMaterno;
    this.dataForm.sexo = this.$store.state.solicitud.sexo;
    this.dataForm.nombreEntidad = this.$store.state.solicitud.nombreEntidad;
    this.dataForm.estadoCivil = this.$store.state.solicitud.estadoCivil;
    this.dataForm.nacionalidad = this.$store.state.solicitud.nacionalidad;

    if (this.$store.state.solicitud.ocupacion != "") {
      this.dataForm.ocupacion = this.$store.state.solicitud.ocupacion;
    }
    if (this.$store.state.solicitud.profesion != "") {
      this.dataForm.profesion = this.$store.state.solicitud.profesion;
    }

    for (let i = 0; i < this.genderOptions.length; i++) {
      if (this.genderOptions[i].value == this.dataForm.sexo) {
        this.dataSexo.label = this.genderOptions[i].label;
        this.dataSexo.value = this.genderOptions[i].value;
      }
    }

    for (let i = 0; i < this.cStateOptions.length; i++) {
      if (this.cStateOptions[i].value == this.dataForm.estadoCivil) {
        this.dataEstadoCivil.label = this.cStateOptions[i].label;
        this.dataEstadoCivil.value = this.cStateOptions[i].value;
      }
    }
  }

  private validFechaNacimiento(año: any, mes: any, dia: any) {
    if (mes > 12) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_BIRTH").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return false;
    } else if (año < 1900) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_BIRTH").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return false;
    } else if (
      (año % 4 !== 0 &&
        año % 100 !== 0 &&
        año % 400 !== 0 &&
        dia > 28 &&
        mes == 2) ||
      (año % 4 === 0 &&
        año % 100 === 0 &&
        año % 400 === 0 &&
        dia > 29 &&
        mes == 2)
    ) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_BIRTH").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return false;
    }
  }
}
